//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyFooter from '@/components/subComponents/MyFooter'
import GoHome from '@/components/subComponents/GoHome'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: "Business",
    components: {
        MyFooter,
        MyBtnReturn,
        GoHome
    },
    data() {
        return {
            datediff: 0,
            dateDiffOptions: [
                {
                    key: '7',
                    value: '一周内'
                },
                {
                    key: '30',
                    value: '一个月内'
                },
                {
                    key: '90',
                    value: '三个月内'
                },
                {
                    key: '180',
                    value: '六个月内'
                },
                {
                    key: '365',
                    value: '一年内'
                },
            ],
            cont_no: '',
            m_bl_no: '',
            lading_id: '',
            consignee_id: '',
        }
    },
    created() {
        document.title = '货物跟踪';
    },
    methods: {
        goResultPage() {
            let route = {
                name: 'BusinessResult',
                query: {
                    cont_no: this.cont_no,
                    m_bl_no: this.m_bl_no,
                    lading_id: this.lading_id,
                    consignee_id: this.consignee_id,
                    datediff: this.datediff,
                }
            };
            this.$router.push(route)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/kehu/business/Business.vue